import React from 'react';
import { Box, TextField } from '@mui/material';

const SessionSummaryField = ({ dataPoint, index, handleFieldChange }) => {
  return (
    <Box sx={{ gap: 1 }}>
      <TextField
        fullWidth
        label='Session Summary'
        margin='dense'
        multiline
        rows={3}
        value={dataPoint.sessionSummary || ''}
        className='input-height'
        sx={{ width: '70%', padding: '0' }}
        onChange={(e) =>
          handleFieldChange(index, 'sessionSummary', e.target.value)
        }
        placeholder='Enter session summary...'
      />
    </Box>
  );
};

export default SessionSummaryField; 